import {HostingDomainData} from "./hostingDomainData";
import {HostingDomainsZoneDataMapper} from "./hosting-domains-zone-mapper";
import * as punycode from "punycode";

export class HostingDomainsDataMapper {
  public static map(domains: any, zones?: any): HostingDomainData {
    const domainsData = domains.reduce((hostingDomainsMapData: any, domain: any) => {
      const hostingDomainData: HostingDomainData = new HostingDomainData();
      hostingDomainData.adminUrl = domain;
      hostingDomainData.cfEnabled = domain.cf_enabled;
      hostingDomainData.createdAt = domain.created_at;
      hostingDomainData.default = domain.default;
      hostingDomainData.domainId = domain.domain_id;
      hostingDomainData.id = domain.id;
      hostingDomainData.name = punycode.toUnicode(domain.name);
      hostingDomainData.OGname = domain.name;
      hostingDomainData.scheme = domain.scheme;
      hostingDomainData.siteUrl = domain.site_url;
      hostingDomainData.updatedAt = domain.updated_at;
      hostingDomainData.httpsEnabled = domain.scheme === "https" ? 1 : 0;
      hostingDomainData.domainPointed = domain.domainPointed ? domain.domainPointed : false;
      if (zones.find((zone: any): any => (zone.name === domain.name))) {
        hostingDomainData.zone = HostingDomainsZoneDataMapper.map(zones.find((zone: any): any => (zone.name === domain.name)));
      }
      else {
        let domainNameSplited = domain.name.split(".");
        if (domainNameSplited.length > 2) {
          domainNameSplited.shift();
          domainNameSplited = domainNameSplited.join(".");
          if (zones.find((zone: any): any => (zone.name === domainNameSplited))) {
            hostingDomainData.zone = HostingDomainsZoneDataMapper.map(zones.find((zone: any): any => (zone.name.toLowerCase() === domainNameSplited.toLowerCase())));
          }
          else {
            hostingDomainData.zone = "";
          }
        }
        else {
          hostingDomainData.zone = "";
        }
      }
      hostingDomainsMapData[domain.id] = hostingDomainData;
      return hostingDomainsMapData;
    }, {});


    return domainsData;
  }


}
